import * as userActions from './constants.js'
import {handleRespErr} from '../../../helpers/respErrorsHandler'

import {API_URLS, buildAPIUrl} from "../../../urls";
import {toastError, toastSuccess} from "../../../helpers/toaster";
import {deleteCookie, deleteLoginCookies, setCookie, setLoginCookies} from "../../../helpers/cookies";
import {setDefaultDashboard} from "../dashboardActions";
import {GetAxios} from "../../../helpers/axios";

export function setAuthData(data) {
    return dispatch => {
        let cookies = {
            access_token: {
                value: data.access_token,
                options: {
                    // 'Domain': process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_DOMAIN,
                }
            },
            authorized: {
                value: true,
                options: {
                    // 'Domain': process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_DOMAIN
                }
            }
        }
        setLoginCookies(cookies);
        dispatch(authorizeActionSuccess(data))
    }
}

function authorizeActionSuccess(data) {
    return {
        type: userActions.AUTHORIZE_SUCCESS,
        payload: data
    }
}

export function authorizeActionFailure(error) {
    return {
        type: userActions.AUTHORIZE_FAILURE,
        error: error
    }
}

export function deleteAuthData() {
    return dispatch => {
        deleteLoginCookies();
        dispatch(deleteAuthDataActionSuccess())
        dispatch(userSignOutAction())
        dispatch(setDefaultDashboard())
    }
}

function deleteAuthDataActionSuccess() {
    return {
        type: userActions.DELETE_AUTH_DATA_SUCCESS,
    }
}


//Get User Referrals

export function getReferrals() {
    return dispatch => {

        let axios = GetAxios(dispatch)

        dispatch(getReferralsRequest());

        axios.get(buildAPIUrl(API_URLS.referralsList), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                dispatch(getReferralsSuccess(res.data));
            })
            .catch(handleRespErr(dispatch, toastError, getReferralsFailure))
    }
}

function getReferralsRequest() {
    return {
        type: userActions.GET_USER_REFERRALS_REQUEST,
    }
}

function getReferralsSuccess(referrals) {
    return {
        type: userActions.GET_USER_REFERRALS_SUCCESS,
        payload: referrals
    }
}

function getReferralsFailure(error) {
    return {
        type: userActions.GET_USER_REFERRALS_FAILURE,
        error: error
    }
}

export function userSignOutAction() {

    return dispatch => {
        let axios = GetAxios(dispatch);

        axios.put(buildAPIUrl(API_URLS.signOut), {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                dispatch(userSignOutSuccess());
            })
            .catch(handleRespErr(dispatch, toastError, userSignOutFailure)) //no changes
    }
}

function userSignOutFailure() {
    return {
        type: userActions.USER_SIGN_OUT_FAILURE
    }
}

export function userSignOutSuccess() {
    return {
        type: userActions.USER_SIGN_OUT_SUCCESS
    }
}


//Get User Personal Info

export function getPersonalInfo() {
    return dispatch => {

        let axios = GetAxios(dispatch)

        dispatch(getPersonalInfoRequest());

        axios.get(buildAPIUrl(API_URLS.personalInfoUser), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                dispatch(getPersonalInfoSuccess(res.data));
            })
            .catch(handleRespErr(dispatch, toastError, getPersonalInfoFailure))
    }
}

function getPersonalInfoRequest() {
    return {
        type: userActions.GET_PERSONAL_INFO_REQUEST,
    }
}

function getPersonalInfoSuccess(personalInfo) {
    return {
        type: userActions.GET_PERSONAL_INFO_SUCCESS,
        payload: personalInfo
    }
}

function getPersonalInfoFailure(error) {
    return {
        type: userActions.GET_PERSONAL_INFO_FAILURE,
        error: error
    }
}

export function sendConfirmationLink(id) {

    return dispatch => {
        let axios = GetAxios(dispatch);
        dispatch(sendConfirmationLinkRequest());

        axios.post(buildAPIUrl(API_URLS.sendConfirmationLink), id, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                dispatch(sendConfirmationLinkSuccess());

                toastSuccess('Confirmation link has been sent.')
                setCookie("timer", "60", {"max-age": 60})
            })
            .catch(handleRespErr(dispatch, toastError, sendConfirmationLinkFailure))
    }
}

function sendConfirmationLinkRequest() {
    return {
        type: userActions.SEND_CONFIRM_EMAIL_LINK_REQUEST,
    }
}

function sendConfirmationLinkSuccess() {
    return {
        type: userActions.SEND_CONFIRM_EMAIL_LINK_SUCCESS,
    }
}

function sendConfirmationLinkFailure(error) {
    return {
        type: userActions.SEND_CONFIRM_EMAIL_LINK_FAILURE,
        error: error
    }
}

//Update Personal Details

export function userUpdatePersonalInfoAction(profileData, cb, wait) {
    return dispatch => {
        let axios = GetAxios(dispatch);

        dispatch(userUpdatePersonalInfoRequest());

        axios.patch(buildAPIUrl(API_URLS.personalInfoUser + '/edit'), profileData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                cb();
                dispatch(userUpdatePersonalInfoSuccess(res.data));
                dispatch(getPersonalInfo());
                toastSuccess(wait ? "Successfully joined. " : 'Information has been updated.')
            })
            .catch(handleRespErr(dispatch, toastError, userUpdatePersonalInfoFailure))
    }
}


function userUpdatePersonalInfoRequest() {
    return {
        type: userActions.USER_UPDATE_PERSONAL_INFO_REQUEST,
    }
}

function userUpdatePersonalInfoSuccess(userData) {
    return {
        type: userActions.USER_UPDATE_PERSONAL_INFO_SUCCESS,
        payload: userData
    }
}

function userUpdatePersonalInfoFailure(error) {
    return {
        type: userActions.USER_UPDATE_PERSONAL_INFO_FAILURE,
        error: error
    }
}

export function endTimer() {
    return {
        type: userActions.END_TIMER
    }
}

export function confirmEmailAction(data, cb) {

    return dispatch => {
        let axios = GetAxios(dispatch);
        dispatch(confirmEmailActionRequest());

        axios.post(buildAPIUrl(API_URLS.confirmEmail), data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((res) => {
                dispatch(confirmEmailActionSuccess())
                deleteCookie('timer')
                setCookie('is_email_confirmed', true, {})
            })
            .catch(err => {
                dispatch(confirmEmailActionFailure(err.response?.data?.error))
            })
    }
}

function confirmEmailActionRequest() {
    return {
        type: userActions.USER_CONFIRM_EMAIL_ACTION_REQUEST,
    }
}

function confirmEmailActionSuccess() {
    return {
        type: userActions.USER_CONFIRM_EMAIL_ACTION_SUCCESS,
    }
}

function confirmEmailActionFailure(error) {
    return {
        type: userActions.USER_CONFIRM_EMAIL_ACTION_FAILURE,
        payload: error
    }
}

export function clearPersonal() {
    return {
        type: userActions.CLEAR_PERSONAL
    }
}



